import PageWrapper from '@app/components/layout/PageWrapper';
import FullLoader from '@app/components/ui/FullLoader';
import { lazy, Suspense } from 'react';
import { useTranslation } from 'react-i18next';

const ClientListPage = lazy(() => import('@pages/clients/ClientListPage'));
const CreateClient = lazy(() => import('@pages/clients/CreateClient').then((m) => ({ default: m.CreateClient })));
const EditClient = lazy(() => import('@pages/clients/EditClient').then((m) => ({ default: m.EditClient })));
const ClientCardPage = lazy(() => import('@pages/clients/ClientCardPage').then((m) => ({ default: m.ClientCardPage })));

// Route Components
const ClientTablePage = () => {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<FullLoader />}>
      <PageWrapper title={t('clients-page-title')}>
        <ClientListPage />
      </PageWrapper>
    </Suspense>
  );
};
const ClientFormPage = () => {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<FullLoader />}>
      <PageWrapper title={t('clients-create-patient')}>
        <CreateClient />
      </PageWrapper>
    </Suspense>
  );
};

const ClientEditPage = () => {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<FullLoader />}>
      <PageWrapper title={t('clients-edit-patient')}>
        <EditClient />
      </PageWrapper>
    </Suspense>
  );
};
const ClientViewPage = () => {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<FullLoader />}>
      <PageWrapper title={t('client-card-page-title')}>
        <ClientCardPage />
      </PageWrapper>
    </Suspense>
  );
};

// Export Lazy-Loaded Route
export default {
  ClientFormPage,
  ClientTablePage,
  ClientEditPage,
  ClientViewPage,
};
